import { render, staticRenderFns } from "./Components.vue?vue&type=template&id=473c5cbc&"
import script from "./Components.vue?vue&type=script&lang=js&"
export * from "./Components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports